import userRoutes from './user'
import accountRoutes from './account'
import servicesRoutes from './services'
import attachmentRoutes from './attachments'
import bankAccountsRoutes from './bankAccounts'
import contactsRoutes from './contacts'
import dashboardRoutes from './dashboard'
import settingRoutes from './settings'
import rightsRoutes from './rights'
import administrationRoutes from './administration'
import routingRoutes from './routing'
import securityRoutes from './security'
import globalRoutes from './global'

export default [
  ...bankAccountsRoutes,
  ...contactsRoutes,
  ...attachmentRoutes,
  ...servicesRoutes,
  ...userRoutes,
  ...dashboardRoutes,
  ...settingRoutes,
  ...accountRoutes,
  ...rightsRoutes,
  ...administrationRoutes,
  ...routingRoutes,
  ...securityRoutes,
  ...globalRoutes
]
